<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div v-if="open" class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">重要提醒</h2>
        </div>
        <div class="modal-body">
          <h4 class="CRM">國泰保單與自行輸入客戶資料的生日不一致</h4>
          <p>系統將以保單所載生日來執行保單健檢</p>
          <template v-if="data">
            <div v-for="(value, index) in data" :key="index">
              <table class="table">
                <tr>
                  <div class="body-tr">
                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <avatar :gender="Number(value.sex)" :size="20" />
                      </div>
                      <div class="font-20 name breakLine text-left">
                        {{ truncate(value.name, 12) }}
                      </div>
                    </div>
                    <div class="rowDiv text-bold">自行輸入客戶資料</div>
                    <div class="bg-border-gray">
                      <div class="rowText">
                        <b>生日 :</b>
                        <span class="birthdayText">{{ value.birthday }}</span>
                      </div>
                    </div>
                    <div class="rowDiv text-bold">
                      國泰保單&nbsp;&nbsp;&nbsp;&nbsp;
                      <span class="text-red text-thin"
                        >※若國泰保單的生日有誤，請盡速協助客戶辦理「保單變更」</span
                      >
                    </div>
                    <div class="bg-border-gray">
                      <div
                        class="rowText"
                        v-for="(item, index2) in value.policies"
                        :key="`${index}_${index2}`"
                      >
                        <div class="row">
                          <div class="col-3">
                            <b>生日 :</b>
                            <span class="birthdayText">{{
                              item.birthday
                            }}</span>
                          </div>
                          <div class="col-3">
                            <span
                              :style="
                                item.insertPolicy ? 'color: #1442c4;' : ''
                              "
                            >
                              {{ item.policyno }}
                            </span>
                          </div>
                          <div class="col-6">
                            <span>{{ item.policyname }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </tr>
              </table>
              <div style="height: 20px"></div>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <div class="action text-right">
            <button
              @click="$emit('close')"
              class="btn btn-default"
              style="width: 120px"
            >
              取消
            </button>
            <button
              @click="$emit('confirm')"
              class="btn btn-primary"
              style="width: 120px"
            >
              確定
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Avatar from "@/desktop/components/Avatar";
import { commonMixin } from "@/mixins/common";
export default {
  name: "bkPolicyAndCustomerBirthCheck",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    diffData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    Avatar,
  },
  data() {
    return {
      data: {},
    };
  },
  watch: {
    open(newVal) {
      this.$el.scrollTop = 0;
      if (newVal) {
        this.fixData();
      }
    },
  },
  methods: {
    moment,
    fixData() {
      let custItem = {};
      this.diffData.forEach((item) => {
        let cust = custItem[item.csidno];
        if (cust) {
          cust.policies.push({
            birthday: this.formatDate(item.ceisdbt),
            policyno: item.ceplcno,
            policyname: item.plan_name,
            insertPolicy: item.plcno,
          });
        } else {
          custItem[item.csidno] = {
            name: item.csname,
            birthday: this.formatDate(item.csbirthday),
            sex: item.sex,
            check: false,
            policies: [
              {
                birthday: this.formatDate(item.ceisdbt),
                policyno: item.ceplcno,
                policyname: item.plan_name,
                insertPolicy: item.plcno,
              },
            ],
          };
        }
      });
      this.data = custItem;
      //難字顯示處理
      this.$nextTick(() => {
        this.registerHanlink();
      });
    },
    formatDate(preDate) {
      if (preDate) {
        let rtnDate = this.moment(preDate).format("YYYY-MM-DD").split("-");
        rtnDate[0] = rtnDate[0] - 1911;
        rtnDate = rtnDate.join("/");
        return rtnDate;
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.CRM {
  color: #00763d;
  margin-top: 0em;
}
table > tr {
  padding: 20px;
  border: 1px solid #53c480;
}
.body-tr {
  padding: 20px 20px;
}
.name {
  font-weight: 600;
  color: #00753f;
}
.rowDiv {
  padding-top: 20px;
  padding-bottom: 10px;
}
.rowText {
  padding: 10px 20px;
}
.birthdayText {
  margin-left: 5px;
}
</style>
